import produce from "immer";
import { IStoreState } from "../initialStoreState";
import { LoadState } from "../../constants/enums";
import { CatalogsActions } from ".";
import {
  FETCH_CATALOG_LIST_PROGRESS,
  FETCH_CATALOG_LIST_SUCCESS,
  FETCH_CATALOG_LIST_FAILED,
  CLEAR_CATALOGS_STATE,
} from "./CatalogsActions";
import { initialCatalogsState } from "./defaultState";
import { ICatalogsState } from "./Catalogs.types";

export const catalogsReducer = (
  state: IStoreState["catalogs"] = initialCatalogsState,
  action: CatalogsActions,
) => {
  switch (action.type) {
    case FETCH_CATALOG_LIST_PROGRESS: {
      const newState = produce(state, (draftState: ICatalogsState) => {
        draftState.list.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_CATALOG_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState: ICatalogsState) => {
        draftState.list.loading = LoadState.Loaded;
        draftState.list.data = data;
        draftState.list.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_CATALOG_LIST_FAILED: {
      const newState = produce(state, (draftState: ICatalogsState) => {
        draftState.list.loading = LoadState.Failed;
      });
      return newState;
    }
    case CLEAR_CATALOGS_STATE: {
      return initialCatalogsState;
    }
    default:
      return state;
  }
};
